import { render, staticRenderFns } from "./TarjetaProducto.vue?vue&type=template&id=7501b32e&scoped=true"
import script from "./TarjetaProducto.vue?vue&type=script&lang=js"
export * from "./TarjetaProducto.vue?vue&type=script&lang=js"
import style0 from "./TarjetaProducto.vue?vue&type=style&index=0&id=7501b32e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7501b32e",
  null
  
)

export default component.exports